import React from "react";

import { Layout, SEO } from "./../layout";
import Page from "./../layout/Page/Page";

export default () => {
  return (
    <Layout>
      <SEO title="2b Band" />
      <Page />
    </Layout>
  );
};
